export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SET_COMPANIES = 'SET_COMPANIES'
export const SET_COMMUNICATION_ITEM = 'SET_COMMUNICATION_ITEM'
export const RESET_COMMUNICATION_ITEM = 'RESET_COMMUNICATION_ITEM'
export const SET_ACTIVE_NOTIFICATION = 'SET_ACTIVE_NOTIFICATION'
export const RESET_ACTIVE_NOTIFICATION = 'RESET_ACTIVE_NOTIFICATION'

export const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS'
export const SET_ACTIVE_COMPANY = 'SET_ACTIVE_COMPANY'
export const RESET_ACTIVE_COMPANY = 'RESET_ACTIVE_COMPANY'

export const SET_COMPANY_NOTIFICATION_COUNT = 'SET_COMPANY_NOTIFICATION_COUNT'

export const SET_WORKFLOWS = 'SET_WORKFLOWS'

export const SET_NOTIFICATION_READ_STATE = 'SET_NOTIFICATION_READ_STATE'
export const SET_NOTIFICATION_LINKED_COMMENT_ID =
  'SET_NOTIFICATION_LINKED_COMMENT_ID'
export const SET_LOADING = 'SET_LOADING'

export const SET_COMMUNICATION_ITEM_DONE = 'SET_COMMUNICATION_ITEM_DONE'
export const SET_COMMUNICATION_ITEM_LAST_REQUESTED_AT =
  'SET_COMMUNICATION_ITEM_LAST_REQUESTED_AT'

export const SET_SEARCH = 'SET_SEARCH'

export const SET_MARKING_AS_READ = 'SET_MARKING_AS_READ'

export const RESET_NOTIFICATION_READ_CACHE = 'RESET_NOTIFICATION_READ_CACHE'
export const RESET_NOTIFICATION_READ_CACHE_FOR_ID =
  'RESET_NOTIFICATION_READ_CACHE_FOR_ID'
